import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=9be8c18e"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports